import { render, staticRenderFns } from "./DatosCompradorParcelas.vue?vue&type=template&id=61d5e574"
import script from "./DatosCompradorParcelas.vue?vue&type=script&lang=js"
export * from "./DatosCompradorParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports